<template>
    <b-modal ref="settingsModal" hide-footer centered @hide="hide();" @close="btnSfx" :title="$t('profile.settings_popup_title')">
        <div class="settingsModal w-100">
            <div class="settingsContent">
                <ul>
                    <li v-if="allInterests != null">
                        <ul>
                            <li class="pl-0"><h4><b>{{ $t('profile.settings_popup_interests_title') }}</b></h4></li>
                            <li v-for="i in allInterests" :key="i.id" @click="toggleInterest(i); toggleSfx();" class="hasSwithch">
                                {{ i.name }} <span :class="'swithch'+(interests.filter(e => e.id == i.id).length > 0 ? ' on' : '')"></span>
                            </li>
                        </ul>
                    </li>

                    <li v-if="settings != null">
                        <ul>
                            <li class="pl-0"><h4><b>{{ $t('profile.settings_popup_notifications_title') }}</b></h4></li>
                            <li @click="settings.notificationGeneral = !settings.notificationGeneral; toggleSfx();" class="hasSwithch">
                                {{ $t('profile.settings_popup_notifications_general_title') }} <span :class="'swithch'+(settings.notificationGeneral ? ' on' : '')"></span>
                            </li>
                            <li @click="settings.notificationQuiz = !settings.notificationQuiz; toggleSfx();" class="hasSwithch">
                                {{ $t('profile.settings_popup_notifications_quiz_title') }} <span :class="'swithch'+(settings.notificationQuiz ? ' on' : '')"></span>
                            </li>
                            <li @click="settings.notificationTeam = !settings.notificationTeam; toggleSfx();" class="hasSwithch">
                                {{ $t('profile.settings_popup_notifications_team_title') }} <span :class="'swithch'+(settings.notificationTeam ? ' on' : '')"></span>
                            </li>
                            <li @click="settings.notificationFamily = !settings.notificationFamily; toggleSfx();" class="hasSwithch">
                                {{ $t('profile.settings_popup_notifications_family_title') }} <span :class="'swithch'+(settings.notificationFamily ? ' on' : '')"></span>
                            </li>
                            <li @click="settings.notificationAuction = !settings.notificationAuction; toggleSfx();" class="hasSwithch">
                                {{ $t('profile.settings_popup_notifications_auction_title') }} <span :class="'swithch'+(settings.notificationAuction ? ' on' : '')"></span>
                            </li>
                            <li @click="settings.notificationRewards = !settings.notificationRewards; toggleSfx();" class="hasSwithch">
                                {{ $t('profile.settings_popup_notifications_rewards_title') }} <span :class="'swithch'+(settings.notificationRewards ? ' on' : '')"></span>
                            </li>
                            <li @click="settings.notificationReferrals = !settings.notificationReferrals; toggleSfx();" class="hasSwithch">
                                {{ $t('profile.settings_popup_notifications_referrals_title') }} <span :class="'swithch'+(settings.notificationReferrals ? ' on' : '')"></span>
                            </li>
                        </ul>
                    </li>

                    <li @click="sound = !sound; toggleSfx();" class="hasSwithch hasAction">
                        {{ $t('profile.settings_popup_sound_title') }} <span :class="'swithch'+(sound ? ' on' : '')"></span>
                    </li>

                    <li v-if="settings != null" @click="swithchSurvey(); toggleSfx();" class="hasSwithch hasAction">
                        {{ $t('profile.settings_popup_survey_title') }} <span :class="'swithch'+(!settings.surveyOptOut ? ' on' : '')"></span>
                    </li>

                    <li class="hasLink hasAction" @click="btnSfx();">
                        <a href="https://adbalu.com/privacy" target="_blank">{{ $t('profile.settings_popup_privacy_link') }}</a>
                    </li>
                    <li class="hasLink hasAction" @click="btnSfx();">
                        <a href="https://adbalu.com/terms" target="_blank">{{ $t('profile.settings_popup_terms_link') }}</a>
                    </li>

                    <li v-if="!clearedBlacklist" @click="clearAdQuizBlacklist(); btnSfx();" class="hasAction">
                        {{ $t('profile.clear_blacklist_settings_btn') }}
                    </li>

                    <li @click="logOut(); btnSfx();" class="hasAction">
                        {{ $t('profile.settings_popup_logout_title') }}
                    </li>

                    <li @click="deleteAccount(); btnSfx();" class="hasAction">
                        {{ $t('profile.settings_popup_delete_account_title') }}
                    </li>
                    
                </ul>
            </div>
            <div class="settingsActions text-center">
                <b-button variant="success" size="lg" @click="save(); btnSfx();" class="pl-4 pr-4">{{ $t('base.btn_save') }}</b-button>
            </div>
        </div>
    </b-modal>
</template>
<script>
import Vue from 'vue'
import api from '../api'

const SettingsPopup = Vue.component('settings-popup', {
    data() {
        return {
            interests: [],
            allInterests: [],
            settings: null,
            sound: true,
            clearedBlacklist: false,
            hasChanges: false,
            init: false,
        }
    },
    methods:{

        toggleSfx(){
            this.$store.dispatch('sound/sfx','Button_OnOff');
        },

        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },

        show() {
            const $this = this;
            this.clearedBlacklist = false;
            this.init = false;
            this.hasChanges = false;
            this.sound = !this.$store.state.sound.mute;

            let loader = document.getElementById('loader');
            loader.classList.add("show");

            api.allInterests()
            .then(response => {
                $this.allInterests = response.data;

                api.interests()
                .then(response => {
                    $this.interests = response.data;

                    api.settings()
                    .then(response => {
                        $this.settings = response.data;
                        $this.$refs.settingsModal.show();
                        loader.classList.remove("show");
                    })
                    .catch(error => {
                        api.baseErrorHendler(error);
                        loader.classList.remove("show");
                    });

                })
                .catch(error => {
                    api.baseErrorHendler(error);
                    loader.classList.remove("show");
                });

            })
            .catch(error => {
                api.baseErrorHendler(error);
                loader.classList.remove("show");
            });
        },

        toggleInterest(i){
            if(this.interests.filter(x => x.id == i.id).length > 0)
                this.interests = this.interests.filter(x => x.id != i.id);
            else
                this.interests.push(i);
        },

        hide() {
            const $this = this;
            if(this.hasChanges == true){
                this.$bvModal.msgBoxConfirm(this.$t('profile.settings_has_changes_text'), {
                    title: this.$t('profile.settings_has_changes_title'),
                    size: 'sm',
                    buttonSize: 'lg',
                    okTitle: this.$t('base.btn_save'),
                    cancelTitle: this.$t('base.btn_cancel'),
                    modalClass: 'confirmModal',
                    hideHeaderClose: false,
                    centered: true,
                })
                .then(value => {
                    if(value){
                        $this.save();
                    }
                })
                .then(value => {
                    $this.$store.dispatch('sound/sfx','Button');
                });
            }
            else 
                this.$refs.settingsModal.hide();
        }, 

        swithchSurvey(){
            this.settings.surveyOptOut = !this.settings.surveyOptOut;
            this.settings.segmentationOptOut = this.settings.surveyOptOut;
            if (!this.settings.surveyOptOut && this.settings.userProfilingStatus != 'ACCEPTED')
                this.openGdpr();
        },

        openGdpr(){
            const $this = this;
            this.$bvModal.msgBoxConfirm(this.htmlToVNode(this.$t('home.popup_profiling_gdpr_text')), {
                title: this.$t('home.popup_profiling_gdpr'),
                size: 'sm',
                buttonSize: 'md',
                okVariant: 'success',
                cancelVariant: 'primary',
                okTitle: this.$t('home.profiling_gdpr_btn_accept'),
                cancelTitle: this.$t('home.profiling_gdpr_btn_reject'),
                modalClass: 'profilingGDPRModal',
                hideHeaderClose: false,
                centered: true,
            })
            .then(value => {
                $this.settings.segmentationOptOut = !value;
                $this.settings.surveyOptOut = !value;
                $this.settings.userProfilingStatus = value ? 'ACCEPTED' : 'REJECTED';
            })
            .then(value => {
                $this.$store.dispatch('sound/sfx','Button');
            });
        },

        htmlToVNode(html) {
            return [
                this.$createElement('div', { domProps: { innerHTML: html } })
            ]
        },

        clearAdQuizBlacklist(){
            const $this = this;
            this.$bvModal.msgBoxConfirm(this.$t('profile.clear_blacklist_popup_sub_text'), {
                title: this.$t('profile.clear_blacklist_popup_title'),
                size: 'sm',
                buttonSize: 'lg',
                okTitle: this.$t('base.btn_ok'),
                cancelTitle: this.$t('base.btn_cancel'),
                modalClass: 'confirmModal',
                hideHeaderClose: false,
                centered: true,
            })
            .then(value => {
                if(value){
                    api.clearAdQuizToBlacklist().then(function (response) {
                        $this.clearedBlacklist = true;
                    })
                    .catch(function (error) {
                        api.baseErrorHendler(error);
                    })
                }
            })
            .then(value => {
                $this.$store.dispatch('sound/sfx','Button');
            });
        },

        deleteAccount(){
            const $this = this;
            let time = this.formatTime(this.userDeletionDelay);
            this.$bvModal.msgBoxConfirm(this.$t('profile.delete_account_text', { time: time }), {
                title: this.$t('profile.delete_account_title'),
                size: 'sm',
                buttonSize: 'lg',
                okTitle: this.$t('base.btn_ok'),
                cancelTitle: this.$t('base.btn_cancel'),
                modalClass: 'confirmModal',
                okVariant: 'danger',
                hideHeaderClose: false,
                centered: true,
            })
            .then(value => {
                if(value){
                    api.deleteAccount().then(function (response) {
                        $this.$router.push({ name: 'logout' });
                    })
                    .catch(function (error) {
                        api.baseErrorHendler(error);
                    })
                }
            })
            .then(value => {
                $this.$store.dispatch('sound/sfx','Button');
            });
        },

        logOut(){
            const $this = this;
            this.$bvModal.msgBoxConfirm(this.$t('profile.logout_popup_text'), {
                title: this.$t('profile.logout_popup_title'),
                size: 'sm',
                buttonSize: 'lg',
                okTitle: this.$t('base.btn_ok'),
                okVariant: 'danger',
                cancelTitle: this.$t('base.btn_cancel'),
                modalClass: 'confirmModal',
                hideHeaderClose: false,
                centered: true,
            })
            .then(value => {
                if(value){
                    $this.$router.push({ name: 'logout' });
                }
            })
            .then(value => {
                $this.$store.dispatch('sound/sfx','Button');
            });
        },

        save(){
            const $this = this;
            let data = {...this.settings};
            if(data.userProfilingStatus == 'PENDING') data.userProfilingStatus = undefined;
            
            let loader = document.getElementById('loader');
            loader.classList.add("show");

            this.$store.dispatch('sound/mute', !this.sound);

            api.setSettings(data)
            .then(function (response) {

                let toSave = $this.interests.map(x => x.id);
                api.updateMe({ interestIds: toSave })
                .then(function (response) {
                    $this.hasChanges = false;
                    $this.$refs.settingsModal.hide();
                    loader.classList.remove("show");
                })
                .catch(function (error) {
                    api.baseErrorHendler(error);
                    loader.classList.remove("show");
                });

            })
            .catch(function (error) {
                api.baseErrorHendler(error);
                loader.classList.remove("show");
            });
        },

        formatTime(time){
            let t = moment.duration(time);

            if(t.asDays() > 1)
                return t.days()+this.$t('base.time_d')+(t.hours() > 0 ? " "+ this.pad2(t.hours())+ this.$t('base.time_h') : "");
            else if(t.hours() > 0)
                return t.hours() + ":" + this.pad2(t.minutes())+this.$t('base.time_h');
            else if(t.minutes() > 0)
                return t.minutes() + ":" + this.pad2(t.seconds())+this.$t('base.time_m');

            return t.seconds()+this.$t('base.time_s');
        },
        pad2(number) {
            if(number < 0) number = 0;
            return (number < 10 ? '0' : '') + number
        },
    },

    computed: {
        user() {
            return this.$store.state.auth.user;
        },
        userDeletionDelay(){
            return this.$store.state.config.data.userDeletionDelay;
        }
    },

    watch: {
        interests: {
            deep: true,
            handler(){
                if(this.init) this.hasChanges = true;
            }
        },
        settings(){
            if(this.init) this.hasChanges = true;
            else this.init = true;
        }
    }
})

export default SettingsPopup
</script>